/*
 * @Description: 企业管理、账户中心、员工管理、系统设置
 * @Author: lijinpeng
 * @Date: 2022-10-09 14:17:38
 * @LastEditTime: 2023-11-14 15:59:22
 * @LastEditors: WangYuhan
 */

import { get, post, prefix } from './base';

// 获取企业列表
export function getCorpList(params) {
  return post(`${prefix}enterprise/getCompanyPage`, params);
}

// 企查查
export function getCompany(params) {
  return get(`${prefix}enterprise/getCompany/${params.name}`, params);
}

// 查询企业万金油余额（旧）
export function queryOilAccountBalance(params) {
  return get(`${prefix}waybillSettlement/queryOilAccountBalance`, params);
}

// 查询企业万金油余额（新）
export function channelAmountByBusinessId(params) {
  return get(`${prefix}oil/channelAmountByBusinessId`, params);
}

// 获取企业账户信息
export function getAccountInfoByBusinessId(params) {
  return get(`${prefix}enterprise/accountInfo`, params);
}

// 查询企业已绑定数据
export function getBankCardByBusinessId(params) {
  return get(`${prefix}enterprise/getBankCardByBusinessId`, params);
}

// 企业绑定银行卡
export function BindingCard(params) {
  return post(`${prefix}enterprise/BindingCard`, params);
}

// 企业信息 鉴权绑卡流程
export function getEnterprise(params) {
  return get(`${prefix}enterprise/getEnterprise/${params.businessId}`, params);
}

// 删除账户信息
export function deletejzbAccountBank(params) {
  return deleted(`${prefix}jzbAccountBank/delete`, params);
}

// 创建企业及开户
export function enterpriseSubmit(params) {
  return post(`${prefix}enterprise/submit`, params);
}

// 回填金额进行绑卡
export function bindCheckAmt(params) {
  return post(`${prefix}openAccount/bindCheckAmt`, params);
}

// 根据卡号返回总行名称
export function getBankByCard(params) {
  return get(`${prefix}common/bank/getBankByCard`, params);
}

// 集团员工信息列表
export function getEmployeeList(params) {
  return get(`${prefix}user/listEmployee`, params);
}

// 角色权限列表查询
export function getUserRole(params) {
  return get(`${prefix}role/findUserRoleGroup`, params);
}

// 添加员工
export function postAddEmployee(params) {
  return post(`${prefix}user/addEmployee`, params);
}

// 删除成员
export function postDeleteUser(params) {
  return post(`${prefix}role/deleteUser`, params);
}

// 修改员工信息
export function postUpdateEmployee(params) {
  return post(`${prefix}user/updateEmployee`, params);
}

// 设置密码
export function setPassword(params) {
  return post(`${prefix}setPassword`, params);
}

// 支付密码设置校验
export function paypwdSetCheck(params) {
  return get(`${prefix}payPwd/paypwdSetCheck`, params);
}

// 发送短信验证码
export function paypwdSmsCode(params) {
  return get(`${prefix}payPwd/smsCode`, params);
}

// 设置交易密码
export function setPayPassword(params) {
  return post(`${prefix}payPwd/pwdSet`, params);
}

// 支付密码开启/禁用 0禁用 1开始
export function pwdStatusUpdate(params) {
  return get(`${prefix}payPwd/pwdStatusUpdate`, params);
}

// 获取当前集团的补贴油款配置
export function getOilConfigList(params) {
  return get(`${prefix}oil/getOilConfigList`, params);
}

//保存补贴油款设置
export function saveOilConfig(params) {
  return post(`${prefix}oil/saveOilConfig`, params);
}

// 集团消息模版列表
export function msgTemplate(params) {
  return get(`${prefix}group/msgTemplate/list`, params);
}

// 设置集团的消息模版
export function msgTemplateupdate(params) {
  return post(`${prefix}group/msgTemplate/update`, params);
}

// 获取系统设置
export function getSetting(params) {
  return get(`${prefix}setting/getSetting`, params);
}

// 保存系统设置
export function saveSetting(params) {
  return post(`${prefix}setting/saveSetting`, params);
}

// 获取集团指定分类的配置
export function getSettingByGroup(params) {
  return get(`${prefix}setting/getSettingByGroup`, params);
}

// 获取系统设置 1增值 2基础
export function getSystemSetting(params) {
  return get(`${prefix}setting/getSystemSetting`, params);
}

// 集团用户列表查询
export function groupUserList(params) {
  return get(`${prefix}page/group/user`, params);
}

// 增加成员查询
export function addGroups(params) {
  return post(`${prefix}employeeUser/addEmployee`, params);
}

// 删除成员查询
export function deleteGroups(params) {
  return post(`${prefix}role/deleteUser`, params);
}

// 编辑成员查询
export function updateGroups(params) {
  return post(`${prefix}employeeUser/updateEmployee`, params);
}

// 集团用户列表查询
export function postGroupUserList(params) {
  return get(`${prefix}employeeUser/listEmployee`, params);
}

// 交接-更换联系人
export function employeeHandover(params) {
  return get(`${prefix}employeeUser/handover`, params);
}

// 更换超级管理员
export function postChangeGroupSuperAdmin(data) {
  return post(`${prefix}uid/changeGroupSuperAdmin`, data);
}

// 获取系统设置：经纪人数据权限
export function getSystemConfigCollect(params) {
  return get(`${prefix}system/configuration/collect/detail`, params);
}

// 更改系统设置：经纪人数据权限
export function postSystemConfigCollectUpdate(data) {
  return post(`${prefix}system/configuration/collect/update`, data);
}

// 更新企业业务配置
export function saveOrUpdateEnterpriseConfig(data) {
  return post(`${prefix}corporationConfig/saveOrUpdateConfig`, data);
}

// 用验证码修改密码
export function resetPasswordBySmsCode(data) {
  return post(`${prefix}employeeUser/resetPasswordBySmsCode`, data);
}

// 用密码修改密码
export function resetPasswordByPassword(data) {
  return post(`${prefix}employeeUser/resetPasswordByPassword`, data);
}

// 获取加入企业列表
export function getCompanys(params) {
  return get(`${prefix}platform/getCompanys`, params);
}

// 获取当前企业得应用列表
export function companyApps(params) {
  return get(`${prefix}platform/companyApps`, params);
}

// 获取最近使用app列表
export function recentlyUsedApp(params) {
  return get(`${prefix}platform/recentlyUsedApp`, params);
}

// 原首页柱状图
export function report(appName) {
  return get(`${prefix}platform/report/${appName}`);
}

export function userApps(params) {
  return get(`${prefix}platform/userApps`, params);
}

// excel导出
export function publicExport(url, params) {
  return post(prefix + url, params);
}

// 设置最近访问
export function setRecentVisit(params) {
  return post(`${prefix}platform/setRecentVisit`, params);
}

// 提交代理商信息进行审核
export function commitAgentCheck(params) {
  return post(`${prefix}dealer/etcwx/sign/commitAgentCheck`, params);
}

// 查询已经提交的申请信息
export function findDealerApply(params) {
  return get(`${prefix}dealer/etcwx/apply/findDealerApply`, params);
}

// 提交代理商申请信息
export function commitDealerApply(params) {
  return post(`${prefix}dealer/etcwx/apply/commitDealerApply`, params);
}

// 获取e签宝地址
export function getDealerContractUrl(params) {
  return get(`${prefix}dealer/etcwx/sign/getDealerContractUrl`, params);
}

// 查询代理商签署结果
// '状态 0 停用(暂停服务) 1 启用(已签约) 2 未签约 3 审核中 4 协议过期 5 审核不通过',
export function findSignResult(params) {
  return post(`${prefix}dealer/etcwx/sign/findSignResult`, params);
}

// 获取企业列表-带分页信息
export function getCompanyPage(params) {
  return post(`${prefix}enterprise/getCompanyPage`, params);
}

// 合同列表
export function pageContract(params) {
  return get(`${prefix}contract/pageContract`, params);
}

// 下载合同
export function downloadContract(params) {
  return get(`${prefix}contract/downloadContract/${params.path}`, params);
}

// 获取签署授权合同url
export function getSignAgencyUrl(params) {
  return get(`${prefix}contract/getSignAgencyUrl`, params);
}

// 账户金额查询
export function queryAccountBalance(params) {
  return get(`${prefix}openAccount/queryAccountBalance`, params);
}

// 获取签署授权合同状态 true已签署，false未签署
export function getSignAgencyStatus(params) {
  return get(`${prefix}contract/getSignAgencyStatus`, params);
}

// 查询充值交易列表
export function queryRechargeList(params) {
  return get(`${prefix}openAccount/queryRechargeList`, params);
}

// 查询提现交易列表
export function queryWithdrawList(params) {
  return get(`${prefix}openAccount/queryWithdrawList`, params);
}

// 开票信息回显
export function invoiceUpdateBefore(params) {
  return get(`${prefix}corporaInvoice/updateBefore`, params);
}

// 开票信息编辑
export function invoiceUpdate(params) {
  return post(`${prefix}corporaInvoice/update`, params);
}

// 邮寄信息编辑
export function invoiceMailUpdate(params) {
  return post(`${prefix}corporaInvoice/mail/update`, params);
}

// 获取牛运宝服务合同url
export function getOneStopServiceAgreementUrl(params) {
  return get(`${prefix}contract/getOneStopServiceAgreementUrl`, params);
}

// 账户中心-企业网货钱包
export function getChannelAccount(params) {
  return get(`${prefix}Account/ChannelAccount`, params);
}

// 设置默认企业
export const setDefaultCorp = params => get(`${prefix}enterprise/setDefault`, params);

// 账户中心-怡亚通企业账户列表
export function listBindCard(params) {
  return post(`${prefix}enterprise/channel/listBindCard`, params);
}

// 账户中心-怡亚通绑卡
export function bindCard(params) {
  return post(`${prefix}enterprise/channel/bindCard`, params);
}
